/**
 * sl-9qm.12: RowDetailConfig Zod Schema
 *
 * Validation schema for row detail page configuration.
 */
import { z } from 'zod';

export const rowDetailConfigSchema = z.object({
  enabled: z.boolean(),
  slugField: z.string().min(1),
  slugFallback: z.enum(['id', 'index']),
  layoutType: z.enum(['article', 'card', 'custom']),
  titleField: z.string().min(1),
  contentField: z.string().optional(),
  coverImageField: z.string().optional(),
  metaFields: z.array(z.string()).max(10),
  showToc: z.boolean(),
  showPrevNext: z.boolean(),
  showBreadcrumb: z.boolean(),
  showRelated: z.boolean(),
  relatedByColumn: z.string().optional(),
  relatedItemsCount: z.number().int().min(1).max(10).optional(),
  seoTitleTemplate: z.string().max(200),
  seoDescriptionField: z.string().optional(),
});
